export enum OnlineOfflineUserStatusValueApi {
  OFFLINE = 1,
  ONLINE = 2,
}
